import { useUserStore } from "@/stores/userStore";
import dayjs from "dayjs";
import { computed } from "vue";

export const useHandleUseBlock = () => {
  const userStore = useUserStore();

  /** 예약제한 상태 여부 */
  const isBookBlocked = computed(() => userStore.isBookBlocked);
  const bookBlockReleaseDisplay = computed(
    () => userStore.bookBlockReleaseDisplay
  );

  /** 탑승제한 상태 여부 */
  const isBoardBlocked = computed(() => userStore.isBoardBlocked);
  const isShuttleBoardBlocked = computed(
    () => !!userStore.userInfo?.isShuttleBoardBlocked
  );
  const boardBlockReleaseDisplay = computed(
    () => userStore.boardBlockReleaseDisplay
  );

  const generateBlockHtml = (
    typeName: string,
    date: string,
    isShuttleBlocked = false
  ) => {
    const displayTypeName = isShuttleBlocked
      ? typeName
      : `${typeName}(사내 제외)`;
    return `<p><em style="font-weight: bold;">${date}</em>까지 ${displayTypeName} 제한되셨습니다.</p>`;
  };

  const blockReleaseDtmHtmlStr = computed(() => {
    if (!isBookBlocked.value && !isBoardBlocked.value) return "";

    if (isBookBlocked.value && !isBoardBlocked.value) {
      return generateBlockHtml("예약", bookBlockReleaseDisplay.value);
    }

    if (!isBookBlocked.value && isBoardBlocked.value) {
      return generateBlockHtml(
        "탑승",
        boardBlockReleaseDisplay.value,
        isShuttleBoardBlocked.value
      );
    }

    const bookBlockEndDtm = userStore.userInfo?.bookBlockEndDtm;
    const boardBlockEndDtm = userStore.userInfo?.boardBlockEndDtm;

    if (
      dayjs(bookBlockEndDtm).isSame(boardBlockEndDtm) &&
      !isShuttleBoardBlocked.value
    ) {
      return generateBlockHtml("예약/탑승", bookBlockReleaseDisplay.value);
    }

    const isBookBlockEndDtmLater =
      dayjs(bookBlockEndDtm).isAfter(boardBlockEndDtm);

    const bookBlockHtml = generateBlockHtml(
      "예약",
      bookBlockReleaseDisplay.value
    );
    const boardBlockHtml = generateBlockHtml(
      "탑승",
      boardBlockReleaseDisplay.value,
      isShuttleBoardBlocked.value
    );

    return isBookBlockEndDtmLater
      ? `${boardBlockHtml}${bookBlockHtml}`
      : `${bookBlockHtml}${boardBlockHtml}`;
  });

  return { isBookBlocked, isBoardBlocked, blockReleaseDtmHtmlStr };
};
